import request from '@/utils/request'

let FulldeliveryApi = {

  /*满送活动列表*/
  list(data) {
    return request._post('/shop/plus.fulldelivery.Index/index', data);
},
/*添加满送活动*/
add(data) {
    return request._post('/shop/plus.fulldelivery.Index/add', data);
}, 
/*修改满送活动*/
edit(data) {
    return request._post('/shop/plus.fulldelivery.Index/edit', data);
},
/*删除满送活动*/
del(data) {
    return request._post('/shop/plus.fulldelivery.Index/del', data);
},
/*满送活动详情*/
detail(data) { 
  return request._post('/shop/plus.fulldelivery.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.fulldelivery.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.fulldelivery.Setting/getSetting', data, errorback);
    },
    editPart(data) {
        return request._post('/shop/plus.fulldelivery.Index/editPart', data);
    },
}
export default FulldeliveryApi;



// WEBPACK FOOTER //
// ./src/api/fulldelivery.js